import React from "react";
import { Breadcrumb, BreadcrumbItem, BreadcrumbLink } from "@chakra-ui/react";
import { useRouter } from "next/router";
import { AI_SHORT_FORM_ALL, AI_WRITER } from "../_utils/routes";

function ShortformBreadcrumb(props) {
  const { category } = props;
  const router = useRouter();

  return (
    <>
      <Breadcrumb
      ml={0}
      sx={{
        ol: {
          marginBottom: "0",
          fontSize: "14px",
        },
      }}
      >
        <BreadcrumbItem>
          <BreadcrumbLink href={AI_WRITER}> AI Writer</BreadcrumbLink>
        </BreadcrumbItem>

        <BreadcrumbItem>
          <BreadcrumbLink href={AI_SHORT_FORM_ALL}>Templates</BreadcrumbLink>
        </BreadcrumbItem>

        {category && (
          <BreadcrumbItem
            isCurrentPage
          >
            <BreadcrumbLink href={`/${AI_SHORT_FORM_ALL}/${category?.title}`}>
              {category?.display_name}
            </BreadcrumbLink>
          </BreadcrumbItem>
        )}
      </Breadcrumb>
    </>
  );
}

export default ShortformBreadcrumb;
